import React, { useRef, useState } from "react";
import * as Icons from "lucide-react";

const ServiceCard = ({ service, index, onClick, lang }) => {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const px = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
    const py = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
    setTilt({ x: -py * 6, y: px * 6 });
  };
  const onLeave = () => setTilt({ x: 0, y: 0 });

  const Icon = Icons[service.icon] || Icons.Sparkles;
  const title = lang === "tr" ? service.title_tr : service.title_en;
  const desc = lang === "tr" ? service.description_tr : service.description_en;

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      onClick={onClick}
      role="button"
      tabIndex={0}
      data-testid={`service-card-${service.key || index}`}
      onKeyDown={(e) => { if (e.key === "Enter") onClick?.(); }}
      style={{
        position: "relative",
        padding: "40px 32px",
        background: "linear-gradient(180deg, rgba(17,17,17,0.95) 0%, rgba(10,10,10,0.95) 100%)",
        border: "1px solid rgba(139,32,53,0.25)",
        cursor: "pointer",
        transform: `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
        transition: "transform 0.4s var(--ease-cinema), border-color 0.4s var(--ease-cinema), background 0.4s var(--ease-cinema)",
        transformStyle: "preserve-3d",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        gap: 16,
      }}
      className="corner-deco"
    >
      <div className="flex items-start justify-between" style={{ transform: "translateZ(40px)" }}>
        <div style={{ width: 56, height: 56, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(201,151,58,0.4)", color: "var(--gold)" }}>
          <Icon size={26} />
        </div>
        <span className="font-mono" style={{ fontSize: "0.75rem", color: "rgba(248,244,240,0.4)", letterSpacing: "0.1em" }}>
          {String(index + 1).padStart(2, "0")}/13
        </span>
      </div>
      <h3 className="font-display" style={{ fontSize: "1.75rem", fontWeight: 400, color: "var(--warm-off-white)", lineHeight: 1.15, transform: "translateZ(30px)" }}>
        {title}
      </h3>
      <p className="font-body" style={{ color: "rgba(248,244,240,0.65)", lineHeight: 1.65, fontSize: "0.95rem", transform: "translateZ(20px)" }}>
        {desc.length > 130 ? desc.slice(0, 127) + "..." : desc}
      </p>
    </div>
  );
};

export default ServiceCard;
